// extracted by css-extract-rspack-plugin
export default {"authorLoginLink":"IssueBodyHeaderAuthor-module__authorLoginLink__aTls_"};